
<div class="lm-search-results-header">
    <p class="section-title">{{ 'Facade_SearchResults' | translate }}</p>
</div>
<div class="lm-header-content">
  <p class="section-title">{{ 'Facade_CreateNewReport' | translate }}</p>
</div>
<div class="lm-facade-cards-wrapper">
  @for (businessObject of businessObjects; track businessObject) {
    <lm-facade-tile
      [title]="businessObject.title"
      [description]="businessObject.description"
      [businessObject]="businessObject"
      [category]="businessObject.category"
      [subCategory]="businessObject.subcategory"
      [selected]="businessObject === selectedBusinessObject"
      [cardWidth]="moduleCardWidth()"
      (businessObjectClicked)="onBusinessObjectClicked($event)"
    ></lm-facade-tile>
  } @empty {
      <div soho-emptymessage [title]="emptyModelSearchTitle" [info]="emptySearchInfo" [icon]="'icon-empty-search-data-new'"></div>
  }
</div>

<div class="lm-header-content">
  <p class="section-title">{{ 'Facade_CopyExistingReport' | translate }}</p>
</div>
<div class="lm-facade-cards-wrapper">
  @for(template of templates; track template) {
    <lm-facade-tile
      [title]="template.reportName"
      [description]="template.description"
      [template]="template"
      [owner]="template.owner.length > 0 ? template.owner : 'Infor'"
      [selected]="template === selectedTemplate"
      [showIcon]="true"
      [cardWidth]="moduleCardWidth()"
      (templateClicked)="onTemplateClicked($event)"
    ></lm-facade-tile>
  } @empty {
      <div soho-emptymessage [title]="emptyReportSearchTitle" [info]="emptySearchInfo" [icon]="'icon-empty-search-data-new'"></div>
  }
</div>

@if(showDetails()) {
  <lm-facade-report-template-detail
    [reportTemplateDetail]="facadeDetailRequest().detail"
  ></lm-facade-report-template-detail>
}
